import { PHOTO_TIDES } from "../constants"

class TidesElement {
  constructor(element, location, token) {
    this.element = element
    this.location = location
    this.token = token
  }

  static fromHtmlElement(htmlElement, location, token) {
    const element = htmlElement.querySelector(PHOTO_TIDES)
    return element ? new TidesElement(element, location, token) : null
  }

  async apply(photo) {
    if (!this.element || !photo.id || !photo.timestamp) {
      // Hide tides if no photo ID or timestamp
      if (this.element) {
        this.element.style.display = "none"
      }
      return
    }

    try {
      const url = `/photos/${photo.id}/tides?location=${encodeURIComponent(this.location)}`
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": this.token,
        },
      })

      if (response.ok) {
        const html = await response.text()
        if (html.trim()) {
          this.element.innerHTML = html
          this.element.style.display = ""
        } else {
          this.element.style.display = "none"
        }
      } else {
        this.element.style.display = "none"
      }
    } catch (error) {
      console.error("Error loading tides:", error)
      this.element.style.display = "none"
    }
  }
}

export default TidesElement
